<template>
  <div class="contact-us">
    <!-- ==================== Office Lacation  ============================== -->
    <div class="bs-docs-section mx-3 my-3 page-wrap">
      <div class="office-location-section">
        <div class="row">
          <div class="col-md-12 text-center mb-2">
            <h4>
              Contact Us
            </h4>
            <hr class="w-80" />
          </div>
        </div>
        <!-- adding contact us locations -->
        <div class="row mb-2 py-3">
          <div
            class="col-sm-12 col-md-12 col-lg-6"
            v-for="(office, index) in Finult_contact_us"
            :key="index"
          >
            <div
              class="row no-gutters border rounded overflow-hidden flex-md-row mb-4 shadow-sm h-md-250 position-relative"
            >
              <div
                class="col-md-6 col-sm-12 p-4 d-flex flex-column position-static"
              >
                <strong class="d-inline-block mb-2 text-primary">
                  {{ office.country }}
                  <span class="vertical-divider"></span>
                  {{ office.city }}
                </strong>

                <h5 class="mb-0 card-title">{{ office.address_title }}</h5>
                <address>
                  <i class="fas fa-map-marker-alt"></i>
                  {{ office.address.address_line1 }}<br />
                  {{ office.address.address_line2 }}<br />
                  {{ office.address.address_line3 }}<br />
                  <br />
                  <i class="fas fa-phone"></i> &nbsp;&nbsp;
                  {{ office.phone_number }}<br />
                  <i class="fas fa-envelope-open-text"></i>
                  <a href="mailto:admin@finult.com"
                    >&nbsp; &nbsp; {{ office.email_address }}</a
                  >
                </address>
              </div>
              <div class="col-md-6 col-sm-12">
                <iframe
                  :src="office.location_map"
                  width="100%"
                  height="100%"
                  frameborder="0"
                  style="border:0;"
                  allowfullscreen=""
                  aria-hidden="false"
                  tabindex="0"
                ></iframe>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import jsonData from "@/components/json/Finult_contact_us.json";
import "@/assets/css/finult-pages.css";
export default {
  name: "ContactUs",
  metaInfo: {
    title: "Contact Us"
  },
  data() {
    return {
      Finult_contact_us: []
    };
  },
  created() {
    console.log(this.$useFirestore);
    if (this.$useFirestore) {
      this.Finult_contact_us = this.$options.filters.getFireStoreRecords(
        "Finult_contact_us"
      );
    } else {
      this.Finult_contact_us = jsonData.Finult_contact_us;
    }
    //console.log(this.Finult_contact_us)
  }
};
</script>

<style></style>
